import React from "react";
import { Svg, Path, Circle } from "react-native-svg";
import { theme } from "@lookiero/sty-psp-ui";

const Brand = () => {
  const { colorIcon } = theme();

  return (
    <Svg fill="none" viewBox="0 0 40 40">
      <Path
        d="M3 17.0466V5C3 3.89543 3.89543 3 5 3H17.0466C17.577 3 18.0857 3.21071 18.4608 3.58579L35.5858 20.7108C36.3668 21.4918 36.3668 22.7582 35.5858 23.5392L23.5392 35.5858C22.7582 36.3668 21.4918 36.3668 20.7108 35.5858L3.58579 18.4608C3.21071 18.0857 3 17.577 3 17.0466Z"
        stroke={colorIcon}
        strokeWidth="2"
      />
      <Circle cx="12" cy="12" r="3" stroke={colorIcon} strokeWidth="2" />
    </Svg>
  );
};

export { Brand };
